
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rv-search",
      function () {
        return require("private-next-pages/rv-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rv-search"])
      });
    }
  